module.exports = __webpack_public_path__ + "static/swashbuckled-ce038e94daedb02aa0d8d39bb90b5529.jpg";